module.exports = __webpack_public_path__ + "static/media/deogratius.da93ba97.jpg";